import { useQuery } from '@tanstack/react-query';
import {
  ClientHealthRange,
  GetClientHealthCountsParams,
  GetClientHealthCountsResponse
} from '@blisspointmedia/bpm-types/dist/OracleApi';
import { OracleLambdaFetch, awaitJSON } from '@src/utils/fetch-utils';
import { CLIENT_HEALTH_COUNTS_QUERY_KEY } from './client-health-constants';

const fetchClientHealthCounts = async (
  params: GetClientHealthCountsParams
): Promise<GetClientHealthCountsResponse> => {
  const res = await OracleLambdaFetch('/recap/client-health/counts', { params });
  return awaitJSON<GetClientHealthCountsResponse>(res);
};

export const useClientHealthCounts = (cid: string, range: ClientHealthRange) =>
  useQuery({
    queryKey: [CLIENT_HEALTH_COUNTS_QUERY_KEY, cid, range],
    queryFn: () => fetchClientHealthCounts({ cid, range }),
    enabled: Boolean(cid),
    meta: { suppressGlobalError: true }
  });
